import { Checkbox, Form, InputNumber } from 'antd'
import { TLeadEngagement } from 'features/automation/types'
import { FC, ReactNode } from 'react'
import CheckBoxCustom from '../components/CheckBoxCustom'

const LeadEngagementItem: FC<{
 helper?: string
 getValueFromEvent?: (any?: any) => void
 name: keyof TLeadEngagement
 label?: string
 labelAffix?: string
 input: React.ReactNode
 action?: ReactNode
}> = ({
 label,
 labelAffix,
 input,
 name,
 action,
 getValueFromEvent,
 helper,
}) => {
 return (
  <div className="ld-engment-item">
   {/* <h3>{label}</h3> */}
   <div className="ld-engment-item-cnt">
    <div>{label}</div>
    <Form.Item
     getValueFromEvent={getValueFromEvent}
     className="mb-0 mx-3"
     name={name}
    >
     {input}
    </Form.Item>
    {labelAffix} {helper && <div className="ld-engment-item-int">{helper}</div>}
   </div>
   {action}
   {/* <div className="smart-listing-item-content">
    {subLabel && <div>{subLabel}</div>}
    <Form.Item className="mb-0" name={name}>
     {input}
    </Form.Item>
   </div> */}
  </div>
 )
}
export default LeadEngagementItem

const LeadEngagementNotification: FC<{
 disabled?: boolean
 getEmailValueFromEvent?: (v?: any) => void
 getPushValueFromEvent?: (v?: any) => void
 readOnly?: boolean
 emailName: keyof TLeadEngagement
 pushName: keyof TLeadEngagement
 label?: string
 labelAffix?: string
}> = ({
 pushName,
 emailName,
 readOnly,
 getEmailValueFromEvent,
 getPushValueFromEvent,
 disabled,
}) => {
 return (
  <div
   className="ld-engment-item-cnt-right"
   data-readony={readOnly}
   style={readOnly ? { pointerEvents: 'none' } : {}}
  >
   <Form.Item
    getValueFromEvent={getEmailValueFromEvent}
    className="mb-0"
    name={emailName}
   >
    <CheckBoxCustom disabled={disabled}>Email</CheckBoxCustom>
   </Form.Item>
   <Form.Item
    getValueFromEvent={getPushValueFromEvent}
    className="mb-0"
    name={pushName}
   >
    <CheckBoxCustom disabled={disabled}>App</CheckBoxCustom>
   </Form.Item>
  </div>
 )
}
export { LeadEngagementNotification }
